export default __webpack_public_path__ + "static/media/signout.b9e7233b.svg";